import { isEmpty } from 'lodash/fp';

import { TARGET_SEGMENT } from '../../../../../cms/constants';
import getOfferToDisplay from '../../utils/get-offer-to-display';
import logging from '../../../../../logging';
import OfferBannerView from '../offer-banner-view';
import useGetActivePromoOffer from '../../../logic/use-get-active-promo-offer';
import type { Offer, OfferPresaleText, OfferRewards, Placeholder } from '../../../types';
import type { OfferBannerVariant } from '../..';
import type { ProductTypeType } from '../../../../../types/product';

type PromoOfferBannerProps = {
  filterProductId?: string;
  filterProductType?: ProductTypeType;
  overrideOffers?: Offer[];
  placeholders?: Placeholder[];
  presaleEnd?: OfferPresaleText;
  presaleSentence?: OfferPresaleText;
  rewards?: OfferRewards;
  targetSegment?: string;
  variant?: OfferBannerVariant;
};

const PromoOfferBanner = ({
  filterProductId,
  filterProductType,
  overrideOffers,
  placeholders,
  presaleEnd,
  presaleSentence,
  rewards,
  targetSegment = TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE,
  variant = 'bordered',
}: PromoOfferBannerProps) => {
  const { activeOffers, loading } = useGetActivePromoOffer({
    skip: !isEmpty(overrideOffers),
    targetSegment,
  });

  if (loading) {
    return <OfferBannerView empty />;
  }

  if (isEmpty(activeOffers) && isEmpty(overrideOffers)) {
    return null;
  }

  const offer = getOfferToDisplay({ activeOffers, filterProductId, filterProductType, overrideOffers });
  if (!offer) {
    if (filterProductId) {
      logging
        .getLogger()
        .error(
          `OfferBanner: No eligible offer found for ${filterProductId}, issue could be in Sanity as offer count is ${activeOffers?.length}`,
        );
    }
    return null;
  }

  return (
    <OfferBannerView
      offer={offer}
      placeholders={placeholders}
      presaleEnd={presaleEnd}
      presaleSentence={presaleSentence}
      rewards={rewards}
      variant={variant}
    />
  );
};

export default PromoOfferBanner;
